import { render, staticRenderFns } from "./LubeDeliveries.vue?vue&type=template&id=7756669b&scoped=true&"
import script from "./LubeDeliveries.vue?vue&type=script&lang=js&"
export * from "./LubeDeliveries.vue?vue&type=script&lang=js&"
import style0 from "./LubeDeliveries.vue?vue&type=style&index=0&id=7756669b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7756669b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAvatar,VBtn,VChip,VChipGroup,VCol,VContainer,VDataTable,VRow,VSnackbar})
